export default __webpack_public_path__ + "87a3bec103af84a9d3ce9f22e77ad3ea.png";